// extracted by mini-css-extract-plugin
export default {"animate":"JBZ7i","fade-in":"fFFnR","form":"yveWv","form__input":"npLDI","form__button-disabled":"eqMYD","form__agree-block":"V2B4W","form__agree-block-link":"gnqzf"};